export default __webpack_public_path__ + "static/media/ManageInfo.fdfbf850.svg";